import { render, staticRenderFns } from "./CurrentBooking.vue?vue&type=template&id=13642a74"
import script from "./CurrentBooking.vue?vue&type=script&lang=js"
export * from "./CurrentBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports